import { Hospital } from "@/Case/models/Hospital";
import { EMSAgency } from "@/types/EMSAgency";
import { FeatureFlags } from "./FeatureFlags";

export const hospitalSupportsCaseFeedback: (Hospital) => boolean = (hospital: Hospital | undefined) => {
  return hospital?.supportedFeatures?.find((feature) => feature.name === "emsFeedback")?.enabled == true;
};

export const teamSupportsCaseFeedback: (EMSAgency) => boolean = (agency: EMSAgency) => {
  return !!agency.hospitals?.find(hospitalSupportsCaseFeedback);
};

export const hospitalRequiresPatientNameAndDOB = (hospital: Hospital | undefined): boolean => {
  return hasSupportedFeature({
    organization: hospital,
    feature: FeatureFlags.caseRequiresPtNameAndDOB,
  });
};

export const hasSupportedFeature = ({
  organization,
  feature,
}: {
  organization: EMSAgency | Hospital | undefined;
  feature: keyof typeof FeatureFlags;
}) => {
  return !!organization?.supportedFeatures?.find((f) => f.name === feature)?.enabled;
};
